<template>
  <!--
  <div class="app flex-row align-items-center"
      :style="{ backgroundImage: 'url(img/background.jpg)' }">
  -->      
  <div class="app app-body flex-row align-items-center">
    <div id="spinner" class="justify-content-center align-items-center"
        :style="{ 
          height: spinnerHeight + 'px', 
          width: spinnerWidth + 'px' }"
        v-if="procesando">
      <b-spinner id="spinner-spin" label="Loading..."></b-spinner>
    </div>

    <div class="container forgot-pwd">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4 login-card">
              <b-card-body>
                <b-form>
                  <h1>Olvidé mi contraseña</h1>
                  <p class="text-muted">Ingrese sus credenciales de acceso</p>
                  <b-form-group>
                    <b-form-input 
                      id="email"
                      placeholder="Email" 
                      v-model.trim= "$v.email.$model" 
                      :state="emailValido"
                      type="text"
                      @blur.native="validate"
                      @focus.native="$event.target.select()">
                    </b-form-input>
                    <b-form-invalid-feedback id="emailFeedback">
                      {{ emailInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-row>
                    <b-col cols="12">
                      <b-button variant="primary" 
                        class="px-4"
                        @click.prevent="forgotPassword">Enviar instrucciones</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>

          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown= 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
// import Alert from  '../shared/msjAlert.vue';
import { msjAlert } from '../../mixins/msjAlert';

export default {
  name: 'Forgot',
  components: {
    // appAlert: Alert
  },
  mixins: [ 
    msjAlert
  ],
  data () {
    return {
      email: '',

      noValidar: true,
      emailValido: null,
      emailInvalidoMsj: '',
    }
  },
  computed: {
    procesando: {
      get: function () {
        return this.$store.getters['spinnerProcesando/procesando'];
      },
      set: function (newValue) {
      }
    },
    spinnerHeight: {
      get: function () {
        return this.$store.getters['spinnerProcesando/height'];
      },
      set: function (newValue) {
      }
    },
    spinnerWidth: {
      get: function () {
        return this.$store.getters['spinnerProcesando/width'];
      },
      set: function (newValue) {
      }
    },
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
            this.$v.$touch();
          
          this.displayErrores(event.target.id);
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'email' || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false;
          if (!this.$v.email.required) {
            this.emailInvalidoMsj = 'Debe ingresar la dirección de correo.';
          } else if (!this.$v.email.email) {
            this.emailInvalidoMsj = 'La dirección de correo no parece ser válida.';
          }
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }
    },
    forgotPassword () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        let params = {
            email: this.email,
        }

        this.showSpinner();
        this.$store.dispatch('user/forgotPassword', params)
          .then(() => {
            this.email = '';
            this.$v.$reset();
            this.showAlert('Se envió un correo a su cuenta con las instrucciones para restablecer su contraseña.', 'info', this.goLogin);
          })
          .catch(error => this.showAlertError(error))
          .finally (() => this.hideSpinner());
      }
    },
    goLogin() {
      this.$router.push({ name: 'Login' });
    }    
  },
  watch: {
  },
  validations: {
    email: {
      required,
      email
    },
  },  
}
</script>

<style>
  .forgot-pwd button.btn-primary {
    width: 180px !important;
  }
</style>
